import { render, staticRenderFns } from "./TopStatisticChart.vue?vue&type=template&id=58441084&scoped=true&"
import script from "./TopStatisticChart.vue?vue&type=script&lang=js&"
export * from "./TopStatisticChart.vue?vue&type=script&lang=js&"
import style0 from "./TopStatisticChart.vue?vue&type=style&index=0&id=58441084&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58441084",
  null
  
)

export default component.exports